var _g, _g2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29851,0,0,1,-3.57838,0.426667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17,2.424C6.741,4.375 12.293,4.186 12.343,3.327C12.403,3.139 12.37,2.923 12.259,2.78C12.259,2.78 10.959,0.124 9.638,-0.03C8.596,-0.152 6.989,1.108 6.474,1.513C6.147,1.771 6.098,2.177 6.17,2.424ZM7.413,2.196C7.351,2.029 8.801,0.882 9.569,0.966C10.097,1.024 11.006,2.337 10.937,2.643C10.849,3.031 7.761,3.133 7.413,2.196Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.29851,0,0,1,27.5343,0.426667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17,2.424C6.741,4.375 12.293,4.186 12.343,3.327C12.403,3.139 12.37,2.923 12.259,2.78C12.259,2.78 10.959,0.124 9.638,-0.03C8.596,-0.152 6.989,1.108 6.474,1.513C6.147,1.771 6.098,2.177 6.17,2.424ZM7.413,2.196C7.351,2.029 8.801,0.882 9.569,0.966C10.097,1.024 11.006,2.337 10.937,2.643C10.849,3.031 7.761,3.133 7.413,2.196Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.887,8.406L3.755,8.406L3.755,19C3.755,20.104 4.651,21 5.755,21L10.887,21L10.887,8.406ZM13.088,8.406L13.088,21L18.22,21C19.323,21 20.22,20.104 20.22,19L20.22,8.406L13.088,8.406Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.378,4.854L13.088,4.854L13.088,7.439L20.378,7.439C20.734,7.439 21.024,7.15 21.024,6.793L21.024,5.5C21.024,5.144 20.734,4.854 20.378,4.854ZM10.887,7.439L10.887,4.854L3.597,4.854C3.241,4.854 2.951,5.144 2.951,5.5L2.951,6.793C2.951,7.15 3.241,7.439 3.597,7.439L10.887,7.439Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/coupons.f386d7f4a38a16c5beaaa4588aed9841.svg";
export { ForwardRef as ReactComponent };